$( document ).ready(function() {
	$('.gol-masters-pool-chbx').change(function() {
    if ($(this).is(':checked')) {
      $(".sport-attributes").hide();
      $(".golf-tournaments").show();
    } else {
      $(".sport-attributes").show();
      $(".golf-tournaments").hide();
    }
	});

  function sortTable(columnIndex) {
    let table = document.querySelector(".golf-pool-table");
    let tbody = table.querySelector("tbody");
    let rows = Array.from(tbody.querySelectorAll("tr"));

    let isAscending = table.getAttribute(`data-sort-${columnIndex}`) !== "asc"; // Toggle sort order

    rows.sort((rowA, rowB) => {
      let cellA = rowA.cells[columnIndex].querySelector("input") 
                  ? rowA.cells[columnIndex].querySelector("input").value.trim() 
                  : rowA.cells[columnIndex].innerText.trim();
      let cellB = rowB.cells[columnIndex].querySelector("input") 
                  ? rowB.cells[columnIndex].querySelector("input").value.trim() 
                  : rowB.cells[columnIndex].innerText.trim();

      // Convert to numbers if sorting Rank (0) or Point Value (2)
      if (columnIndex === 0 || columnIndex === 1) {
        a = parseInt(cellA) || 0; // Default to 0 if empty or NaN
        b = parseInt(cellB) || 0;
      } else {
        a = cellA.toLowerCase();
        b = cellB.toLowerCase();
      }

      return isAscending ? (a > b ? 1 : -1) : (a < b ? 1 : -1);
    });

    // Append sorted rows back to table
    rows.forEach(row => tbody.appendChild(row));

    // Toggle sort order attribute
    table.setAttribute(`data-sort-${columnIndex}`, isAscending ? "asc" : "desc");
  }

  window.sortTable = sortTable;
});

document.addEventListener("DOMContentLoaded", function () {
  let searchInput = document.getElementById("golf-pool-search");

  if (searchInput) {
    searchInput.addEventListener("keyup", function () {
      let filter = this.value.toLowerCase();
      let rows = document.querySelectorAll(".golf-pool-table tbody tr");

      rows.forEach(row => {
        let rank = row.cells[1]?.innerText.toLowerCase() || ""; // Adjusted index (checkbox is in column 0)
        let player = row.cells[2]?.innerText.toLowerCase() || "";
        let points = row.cells[3]?.innerText.toLowerCase() || "";

        if (rank.includes(filter) || player.includes(filter) || points.includes(filter)) {
          row.style.display = "";
        } else {
          row.style.display = "none";
        }
      });
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  let searchInput = document.getElementById("golf-pool-search-admin");

  console.log(searchInput)

  if (searchInput) {
    searchInput.addEventListener("keyup", function () {
      let filter = this.value.toLowerCase();
      let rows = document.querySelectorAll(".golf-pool-table tbody tr");

      rows.forEach(row => {
        let player = row.cells[0]?.innerText.toLowerCase() || "";
        let points = row.cells[1]?.querySelector("input")?.value.toLowerCase() || "";

        if (player.includes(filter) || points.includes(filter)) {
          row.style.display = "";
        } else {
          row.style.display = "none";
        }
      });
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  let saveTeamForm = document.getElementById("save-team-form");
  if (!saveTeamForm) return;

  let checkboxes = document.querySelectorAll(".player-checkbox");
  let summaryBody = document.getElementById("summary-body");
  let selectedPlayersContainer = document.getElementById("selected-players-container");
  let summaryTotalDisplay = document.getElementById("summary-total");
  let selectedCountDisplay = document.getElementById("selected-count");
  // let remainingCountDisplay = document.getElementById("remaining-count");
  let salaryRemainingDisplay = document.getElementById("salary-remaining");
  let errorMessage = document.getElementById("error-message");
  let tiebreakerInput = document.querySelector(".tiebreaker-input");
  let saveButton = document.querySelector(".save-team-btn");

  let maxPlayers = 8;
  let maxPoints = 50;
  let selectedCount = 0;
  let totalPoints = 0;

  checkboxes.forEach(checkbox => {
    checkbox.addEventListener("change", function () {
      let playerId = this.getAttribute("data-player-id");
      let playerName = this.getAttribute("data-player-name");
      let playerPoints = parseInt(this.getAttribute("data-player-points")) || 0;

      if (this.checked) {
        if (selectedCount >= maxPlayers) {
          this.checked = false;
          alert("You must select exactly 8 players.");
          return;
        }

        if (totalPoints + playerPoints > maxPoints) {
          this.checked = false;
          alert("Total selected players' points cannot exceed 50.");
          return;
        }

        let newRow = document.createElement("tr");
        newRow.setAttribute("data-player-id", playerId);
        newRow.innerHTML = `<td>${playerName}</td><td>${playerPoints}</td>`;
        summaryBody.appendChild(newRow);

        let hiddenInput = document.createElement("input");
        hiddenInput.type = "hidden";
        hiddenInput.name = "players[]";
        hiddenInput.value = playerId;
        hiddenInput.setAttribute("data-player-id", playerId);
        selectedPlayersContainer.appendChild(hiddenInput);

        selectedCount++;
        totalPoints += playerPoints;
      } else {
        let selectedRow = summaryBody.querySelector(`[data-player-id='${playerId}']`);
        if (selectedRow) summaryBody.removeChild(selectedRow);

        let hiddenInput = selectedPlayersContainer.querySelector(`[data-player-id='${playerId}']`);
        if (hiddenInput) selectedPlayersContainer.removeChild(hiddenInput);

        selectedCount--;
        totalPoints -= playerPoints;
      }

      selectedCountDisplay.textContent = selectedCount.toString();
      // remainingCountDisplay.textContent = (maxPlayers - selectedCount).toString();
      salaryRemainingDisplay.textContent = Math.max(maxPoints - totalPoints, 0).toString();
      summaryTotalDisplay.textContent = totalPoints.toString();

      saveButton.removeAttribute("disabled");
    });
  });

  saveTeamForm.addEventListener("submit", function (event) {
    let tiebreakerValue = tiebreakerInput.value.trim();
    errorMessage.style.display = "none";
    errorMessage.textContent = "";

    if (selectedCount !== maxPlayers) {
      event.preventDefault();
      errorMessage.textContent = "You must select exactly 8 players.";
      errorMessage.style.display = "block";
      setTimeout(() => saveButton.disabled = false, 100); 
      return false;
    }

    if (totalPoints > maxPoints) {
      event.preventDefault();
      errorMessage.textContent = "Total points cannot exceed 50.";
      errorMessage.style.display = "block";
      setTimeout(() => saveButton.disabled = false, 100); 
      return false;
    }

    if (tiebreakerValue === "") {
      event.preventDefault();
      errorMessage.textContent = "Tiebreaker is required.";
      errorMessage.style.display = "block";
      setTimeout(() => saveButton.disabled = false, 100); 
      return false;
    }

    errorMessage.style.display = "none";
  });

  checkboxes.forEach(cb => {
    if (cb.checked) cb.dispatchEvent(new Event('change'));
  });

});

document.addEventListener("DOMContentLoaded", function () {
  const toggle = document.querySelector(".golf-pool-dropdown-toggle");
  const menu = document.querySelector(".golf-pool-dropdown-menu");

  if (toggle && menu) {
    toggle.addEventListener("click", () => {
      menu.style.display = menu.style.display === "block" ? "none" : "block";
    });

    document.addEventListener("click", function (e) {
      if (!toggle.contains(e.target) && !menu.contains(e.target)) {
        menu.style.display = "none";
      }
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('[data-show-toast="true"]').forEach(el => {
    el.addEventListener("click", function () {
      const toast = document.getElementById("select-team-toast");
      toast.style.display = "block";
      setTimeout(() => toast.style.display = "none", 3000);
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const button = document.querySelector(".golf-pool-launcher");
  const modal = document.getElementById("golf-pool-modal");
  const listContainer = document.getElementById("golf-pool-competition-list");
  const closeModal = document.querySelector(".golf-pool-modal-close");

  if (!button) return;
  
  button.addEventListener("click", function () {
    fetch("/golf_pool/available_competitions")
      .then(res => res.json())
      .then(data => {
        listContainer.innerHTML = "";

        if (data.length === 0) {
          const msg = document.createElement("div");
          msg.className = "golf-pool-empty-msg";
          msg.textContent = "No active or upcoming Golf Pool competitions found.";
          listContainer.appendChild(msg);
        } else {
          data.forEach(comp => {
            const li = document.createElement("li");
            li.className = "golf-pool-competition-item";
            li.textContent = `${comp.name}`;

            li.addEventListener("click", function () {
              const path = comp.team_selected
                ? `/competition/standings?id=${comp.id}`
                : `/competitions/${comp.id}/players/${comp.player_id}/select_team`;

              window.location.href = path;
            });

            listContainer.appendChild(li);
          });
        }

        modal.style.display = "flex";
      })
      .catch(error => {
        console.error("Error fetching competitions:", error);
        listContainer.innerHTML = "<div class='golf-pool-empty-msg'>Failed to load competitions.</div>";
        modal.style.display = "flex";
      });
  });

  closeModal.addEventListener("click", function () {
    modal.style.display = "none";
  });

  window.addEventListener("click", function (e) {
    if (e.target === modal) {
      modal.style.display = "none";
    }
  });
});

// Add payouts code

document.addEventListener('DOMContentLoaded', () => {
  const payoutsBody = document.getElementById('payouts-body');
  const addRowBtn = document.getElementById('add-row-btn');

  if (!payoutsBody || !addRowBtn) return;

  const updateTotal = () => {
    const fields = document.querySelectorAll('.payout-field');
    let sum = 0;
    fields.forEach(input => {
      const val = parseFloat(input.value);
      if (!isNaN(val)) sum += val;
    });
    document.getElementById('total-payout').textContent = sum.toFixed(1);
  };

  const updateDeleteButton = () => {
    document.querySelectorAll('.delete-row-btn').forEach(btn => btn.remove());
    const lastRow = payoutsBody.lastElementChild;
    if (lastRow) {
      const cell = lastRow.children[2];
      const deleteBtn = document.createElement('button');
      deleteBtn.type = 'button';
      deleteBtn.innerText = '❌';
      deleteBtn.className = 'delete-row-btn';
      deleteBtn.onclick = () => {
        payoutsBody.removeChild(lastRow);
        updateDeleteButton();
        updateTotal();
      };
      cell.appendChild(deleteBtn);
    }
  };

  addRowBtn.addEventListener('click', () => {
    const rowCount = payoutsBody.children.length;
    const tr = document.createElement('tr');

    const placeTd = document.createElement('td');
    placeTd.innerText = `${rowCount + 1}${getOrdinalSuffix(rowCount + 1)} Place`;

    const inputTd = document.createElement('td');
    const input = document.createElement('input');
    input.type = 'number';
    input.name = `payouts[${rowCount}]`;
    input.step = '0.1';
    input.className = 'payout-field';
    input.addEventListener('input', updateTotal);
    inputTd.appendChild(input);
    inputTd.insertAdjacentText('beforeend', ' %');

    const deleteTd = document.createElement('td');

    tr.appendChild(placeTd);
    tr.appendChild(inputTd);
    tr.appendChild(deleteTd);
    payoutsBody.appendChild(tr);

    updateDeleteButton();
    updateTotal();
  });

  const getOrdinalSuffix = (i) => {
    const j = i % 10, k = i % 100;
    if (j == 1 && k != 11) return "st";
    if (j == 2 && k != 12) return "nd";
    if (j == 3 && k != 13) return "rd";
    return "th";
  };

  document.querySelectorAll('.payout-field').forEach(input => {
    input.addEventListener('input', updateTotal);
  });

  updateDeleteButton();
  updateTotal();
});
